import { account } from '../core/account.js';
import { i18n, t } from '../core/i18n.js';
import { escapeHtml } from '../core/utils.js';

/* Cuestionario de los testeadores de la beta (solo administradores): resumen, lista de respuestas y detalle. Habla con
   /api/survey/admin/* (server/survey.js); es lo mismo que scripts/survey.js pero desde la aplicación. Los nombres de los aspectos
   (Instalación, Rapidez…) llegan ya escritos del servidor, en español, como el propio cuestionario. */

export function openSurveyAdmin() {
    const app = window.app;
    const id = 'survadm-' + Date.now().toString(36);
    const popup = app.popup.create({
        content: `<div class="popup catpick-popup admin-popup" id="${id}">
            <div class="page">
                <div class="navbar"><div class="navbar-bg"></div><div class="navbar-inner">
                    <div class="title">${t('survey.admin.title')}</div>
                    <div class="right"><a href="#" class="link popup-close btn-icon" aria-label="${t('common.close')}"><span class="mi">close</span></a></div>
                </div></div>
                <div class="page-content"><div class="phone-body" data-adm></div></div>
            </div>
        </div>`,
        on: {
            open(p) {
                const body = (p.el || document.getElementById(id)).querySelector('[data-adm]');
                const call = (method, path) => account.request(method, path, {});
                const when = (ms) => new Date(ms).toLocaleString(i18n.lang, { dateStyle: 'medium', timeStyle: 'short' });
                const cap = (x) => x.charAt(0).toUpperCase() + x.slice(1);
                const fail = () => { body.innerHTML = `<div class="phone-status is-error">${t('common.errorNetwork')}</div>`; };
                const line = (label, value) => (value === null || value === undefined || value === '' ? '' : `<div class="admin-user-sub"><b>${escapeHtml(label)}:</b> ${escapeHtml(String(value))}</div>`);

                const listScreen = async () => {
                    body.innerHTML = '<div class="spinner"></div>';
                    let data;
                    try { data = await call('GET', '/api/survey/admin/list'); } catch (e) { return fail(); }
                    const s = data.summary;
                    if (!s.count) { body.innerHTML = `<p class="pw-note">${t('survey.admin.empty')}</p>`; return; }
                    const nps = s.nps ? `${t('survey.admin.avgRec')}: ${s.nps.avg}/10 · NPS ${s.nps.score}` : '';
                    body.innerHTML = `<h3>${t('survey.admin.summary')} · ${s.count} ${t('survey.admin.responses')}</h3>
                        ${nps ? `<div class="admin-user-sub">${escapeHtml(nps)}</div>` : ''}
                        <h4>${t('survey.admin.ratings')}</h4>
                        ${s.ratings.map((r) => `<div class="admin-user-sub">${escapeHtml(r.label)}: <b>${r.avg}</b> (${r.n})</div>`).join('')}
                        <h4>${t('survey.admin.bugs')}</h4>
                        <div class="admin-user-sub">${s.severity.map((x) => `${escapeHtml(x.label)} ${x.n}`).join(' · ')}</div>
                        <h4>${t('survey.admin.would')}</h4>
                        <div class="admin-user-sub">${s.would.map((x) => `${escapeHtml(x.label)} ${x.n}`).join(' · ')}</div>
                        ${s.tested.length ? `<h4>${t('survey.admin.tested')}</h4><div class="admin-user-sub">${s.tested.map((x) => `${escapeHtml(x.label)} ${x.n}`).join(' · ')}</div>` : ''}
                        <h4>${cap(t('survey.admin.responses'))}</h4>
                        ${data.responses.map((r) => `<button type="button" class="admin-user" data-resp="${r.id}" style="width:100%;text-align:left">
                            <span class="admin-avatar mi">${r.severity === 'blocking' ? 'error' : r.severity === 'minor' ? 'bug_report' : 'rate_review'}</span>
                            <div class="admin-user-body">
                                <div class="admin-user-name">#${r.id} ${escapeHtml(r.name || '—')}${r.nps === null ? '' : ` <span class="tag">${r.nps}/10</span>`}${r.avg === null ? '' : ` <span class="tag tag-off">★ ${r.avg}</span>`}</div>
                                <div class="admin-user-sub">${escapeHtml([r.device, r.install, r.model].filter(Boolean).join(' · '))} · ${escapeHtml(when(r.createdAt))}${r.severityLabel ? ' · ' + escapeHtml(r.severityLabel) : ''}</div>
                            </div>
                        </button>`).join('')}`;
                };

                const detailScreen = async (respId) => {
                    body.innerHTML = '<div class="spinner"></div>';
                    let r;
                    try { r = (await call('GET', '/api/survey/admin/get?id=' + encodeURIComponent(respId))).response; } catch (e) { return fail(); }
                    body.innerHTML = `<button type="button" class="btn" data-back><span class="mi">arrow_back</span>${t('common.back')}</button>
                        <div class="phone-status" style="white-space:pre-wrap">${escapeHtml(r.text)}</div>`;
                };

                body.onclick = (e) => {
                    if (e.target.closest('[data-back]')) return listScreen();
                    const r = e.target.closest('[data-resp]');
                    if (r) detailScreen(r.getAttribute('data-resp'));
                };
                listScreen();
            },
            closed() {
                try { popup.destroy(); } catch (e) { /* ya destruido */ }
                const el = document.getElementById(id);
                if (el && el.parentNode) el.parentNode.removeChild(el);
            }
        }
    });
    popup.open();
    return popup;
}
